import { Card, Col, Form, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import CreatableSelect from 'react-select/creatable';
import { RHFControl } from 'components/common/form';

// Common answers first; anything else can still be typed in (the box keeps
// whatever was written, e.g. existing lower-case "pilot" records).
export const ASPIRATION_OPTIONS = [
  'Ustadh',
  'Ustadha',
  'Teacher',
  'Doctor',
  'Nurse',
  'Pilot',
  'Lawyer',
  'Engineer',
  'Scientist',
  'Police Officer',
  'Businessperson'
].map(v => ({ label: v, value: v }));

const toOption = value =>
  value ? { label: String(value), value: String(value) } : null;

export const InspirationCard = ({ sectionRef, sideNavLink }) => {
  const { control } = useFormContext();
  return (
    <Card className="border shadow-none mb-3" ref={sectionRef} id={sideNavLink}>
      <Card.Header className="pb-0">
        <div className="dFlexRowStartSpace pt-3">
          <Card.Title as="h5">Inspiration</Card.Title>
        </div>
      </Card.Header>
      <Card.Body>
        <Row className="gx-3 gy-3">
          <Col xs={12} md={6}>
            <Controller
              name="inspiration"
              control={control}
              render={({
                field: { value, onChange },
                fieldState: { error }
              }) => {
                const current = toOption(value);
                const options =
                  current &&
                  !ASPIRATION_OPTIONS.some(
                    o => o.value.toLowerCase() === current.value.toLowerCase()
                  )
                    ? [...ASPIRATION_OPTIONS, current]
                    : ASPIRATION_OPTIONS;
                return (
                  <Form.Group>
                    <Form.Label>
                      Career Aspiration{' '}
                      <span className="text-500">(optional)</span>
                    </Form.Label>
                    <CreatableSelect
                      inputId="inspiration"
                      classNamePrefix="react-select"
                      isClearable
                      placeholder="Choose or type..."
                      options={options}
                      value={current}
                      onChange={opt => onChange(opt?.value || '')}
                      formatCreateLabel={text => `Use "${text}"`}
                      components={{ IndicatorSeparator: () => null }}
                    />
                    {error && (
                      <Form.Control.Feedback className="d-block" type="invalid">
                        {error.message}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                );
              }}
            />
          </Col>
          <Col xs={12} md={6}>
            <RHFControl
              name="hobbies"
              label="Interests / Hobbies"
              placeholder="e.g. Football, reading, drawing"
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

InspirationCard.propTypes = {
  sectionRef: PropTypes.object,
  sideNavLink: PropTypes.string
};
